import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Radio, Space, Table } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { IoIosWarning } from 'react-icons/io';
import { IDevice } from '@pages/Assets/Inventory/types';

type useIntroStepType = {
  devicesByBlockingType: any;
  extraAction: number;
  setextraAction: Dispatch<SetStateAction<number>>;
  actionDisabled: number;
  devicesProps: IDevice[] | undefined;
  uploadReinitState: () => void;
};

const useIntroStep = ({
  devicesByBlockingType,
  extraAction,
  setextraAction,
  actionDisabled,
  devicesProps,
  uploadReinitState,
}: useIntroStepType) => {
  const { t: translate } = useTranslation([
    'device-actions-modal',
    'device-actions',
  ]);

  const introStep = useMemo(() => {
    return (
      <Space
        direction="vertical"
        size="large"
        align="center"
        style={{ width: '100%' }}
      >
        {devicesByBlockingType.devicesToBlock &&
          devicesByBlockingType.devicesToUnblock && (
            <div className="network-block-both-warning">
              <IoIosWarning className="both-warning-icon" />
              <div>{translate('steps.network-block.warning-devices')}</div>
              <div>{translate('steps.network-block.description')}</div>
            </div>
          )}
        <div className="network-block-radio">
          <Radio.Group
            name="radiogroup"
            defaultValue={20}
            style={{ display: 'flex', justifyContent: 'center' }}
            value={extraAction}
            onChange={e => {
              setextraAction(e.target.value);
              uploadReinitState();
            }}
          >
            <Radio.Button
              value={20}
              disabled={actionDisabled === 20}
              className="block-card-option"
            >
              <div style={{ lineHeight: '1' }}>
                {translate('steps.network-block.label-button-block')}
              </div>
            </Radio.Button>
            <Radio.Button
              value={21}
              disabled={actionDisabled === 21}
              className="block-card-option"
            >
              <div style={{ lineHeight: '1' }}>
                {translate('steps.network-block.label-button-unblock')}
              </div>
            </Radio.Button>
          </Radio.Group>
        </div>

        {devicesProps && devicesProps.length > 0 && (
          <Space direction="vertical" size="large" style={{ color: '#8C9696' }}>
            <Trans
              t={translate}
              i18nKey="steps.network-block.warning-devices2"
              values={{
                action: translate(`device-actions:labels.${extraAction}`),
                quantity:
                  extraAction === 20
                    ? devicesByBlockingType?.devicesToBlock?.length
                    : devicesByBlockingType?.devicesToUnblock?.length,
              }}
            >
              <b style={{ color: 'var(--primary-color)' }}>
                {translate(`device-actions:labels.${extraAction}`)}
              </b>

              <b style={{ color: 'var(--primary-color)' }}>
                {extraAction === 20
                  ? devicesByBlockingType?.devicesToBlock?.length
                  : devicesByBlockingType?.devicesToUnblock?.length}
              </b>
            </Trans>

            <div style={{ maxWidth: 500, width: '100%', overflowX: 'auto' }}>
              <Table
                className="network-block-table"
                rowKey={record => record.id}
                size="small"
                dataSource={
                  extraAction === 20
                    ? devicesByBlockingType?.devicesToBlock
                    : devicesByBlockingType?.devicesToUnblock
                }
                columns={[
                  {
                    key: 'customerName',
                    title: () => translate('customer'),
                    dataIndex: 'customerName',
                  },
                  {
                    key: 'msisdn',
                    title: 'MSISDN',
                    dataIndex: 'msisdn',
                  },
                ]}
                pagination={false}
                scroll={{ x: 'max-content' }}
              />
            </div>
          </Space>
        )}
      </Space>
    );
  }, [
    actionDisabled,
    devicesByBlockingType.devicesToBlock,
    devicesByBlockingType.devicesToUnblock,
    extraAction,
    setextraAction,
    translate,
    devicesProps,
    uploadReinitState,
  ]);

  return {
    introStep: {
      title: translate('steps.network-block.step1'),
      content: introStep,
    },
  };
};

export default useIntroStep;
